import { render, staticRenderFns } from "./taskAllocationView.vue?vue&type=template&id=1c099402&"
import script from "./taskAllocationView.vue?vue&type=script&lang=js&"
export * from "./taskAllocationView.vue?vue&type=script&lang=js&"
import style0 from "./taskAllocationView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports